import { Grid as BaseGrid, Divider as DividerBase, styled } from '@mui/material'

export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  align-items: center;
  width: 100%;
`
export const Divider = styled(DividerBase)``

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 28px;
  cursor: pointer;
  text-decoration: none;
`
export const LinkDocument = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
`
